// Drop-off and pick-up per day (0022). English counterpart of ridesApp.nl.ts.
export const appRidesEn = {
    unknown: 'Not known yet',
    notNeeded: 'Not needed',
    perDay: 'Different per day',
    perDayHint: 'For example Monday {a} and Thursday {b}.',
    perDayHintOne: 'For example someone else on Monday than on Thursday.',
    sameEveryDay: 'Same every time',
    day: 'Day',
    roleOnDay: '{role} on {day}',
    change: 'Change',
    close: 'Done',
    droppedDays: {
        one: 'The driver for {days} is removed: that day is no longer part of the repeat.',
        other: 'The drivers for {days} are removed: those days are no longer part of the repeat.',
    },
    cantDrive: 'Can’t make it? Someone else',
    /** Eigen rit: laat hem open ("Wie rijdt?"), de ander ziet hem. */
    iCant: 'I can’t, leave open',
    /** Eigen rit: meteen kiezen wie het overneemt. */
    someoneElse: 'Someone else drives',
    whoInstead: 'Who {role} on {date}?',
    whoInsteadHint: 'Only this time. The other times stay as they are.',
    onlyThisTime: 'Only this time',
    usually: 'usually {name}',
    usuallyNobody: 'usually nobody yet',
    everyWeekday: 'every {day}',
    backToUsual: 'Back to usual',
    takenOver: '{name} {role} this time',
    nobodyNow: '{role} is marked "Who drives?" this time. The others can see it.',
    backDone: '{role} back to usual',
    verbDropoff: 'drops off',
    verbPickup: 'picks up',
};
//# sourceMappingURL=ridesApp.en.js.map